<template>
 <v-container fluid>
  <v-row >
   <v-col cols="12" sm="12" md="12">
    <v-card class="elevation-12">
     <v-toolbar dark flat> <v-toolbar-title>Ad. List</v-toolbar-title></v-toolbar>
     <!--- Search ---->
     <v-row> 
       <v-col cols="1" sm="1" md="1" class="text-right padding-top-0 padding-bottom-0"><br>Search</v-col>
       <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
            <v-select v-model="websiteid"  :items="websitelist" item-text="publisherName" item-value="publisherId"  @change="getzonelist($event)" label="--Select Website--"  class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
                <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                  <v-select v-model="adtype"  :items="adtypelist"  label="--Select Banner type--"  class="padding-top-0 padding-bottom-0" ></v-select>
                </v-col>
                <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-menu ref="searchfrom_date"  v-model="searchfrom_date"  :close-on-content-click="false"
                                                        :return-value.sync="searchfrom_date" transition="scale-transition"  offset-y  min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <v-text-field  v-model="searchfromdate"  label="From Date"
                                                            prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker  v-model="searchfromdate"  no-title  scrollable>
                                                          <v-spacer></v-spacer>
                                                          <v-btn    text  color="primary"  @click="searchfromdate = false">
                                                            Cancel    </v-btn>
                                                          <v-btn  text   color="primary" @click="$refs.searchfrom_date.save(searchfrom_date)" >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    </v-col>
                                                      <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-menu ref="to_date"  v-model="searchto_date"  :close-on-content-click="false"
                                                        :return-value.sync="searchto_date" transition="scale-transition"  offset-y  min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <v-text-field            v-model="searchtodate"            label="To Date"
                                                            prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker  v-model="searchtodate"  no-title  scrollable>
                                                          <v-spacer></v-spacer>
                                                          <v-btn    text  color="primary"  @click="searchtodate = false">
                                                            Cancel    </v-btn>
                                                          <v-btn  text   color="primary" @click="$refs.searchto_date.save(searchto_date)" >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    </v-col>
                                              <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-btn   depressed color="primary" @click="getBannersList()"><v-icon left>mdi-file-search-outline
                                                      </v-icon>Search</v-btn>
                                              </v-col>
              </v-row>
            <!--- End Search----->
            <v-data-table  :headers="headers" :items="getbannerslist" :items-per-page="10"  class="elevation-1" >
            <template v-slot:item.sno="{ item }">
                 {{ item.sno }}
                </template>
                 <template v-slot:item.bannertitle="{ item }">
                   <a href="#" @click="showdetails(item.id)">
                   {{ item.bannertitle }} 
                   </a>
                </template>
                <template v-slot:item.remaining_amount="{ item }">
                  
                 USD {{ item.remaining_amount }} 
                  
               </template>
                <template v-slot:item.startdate="{ item }">
                    {{ item.startdate }} 
                </template>
                <template v-slot:item.enddate="{ item }">
                  {{ item.enddate }}
                </template>
                  <template v-slot:item.adplacementid="{ item }">
                    {{ item.adplacementid }}
                </template>
                <template v-slot:item.adtype="{ item }">
                  {{ item.adtype }}
                </template>
                <template v-slot:item.status="{ item }" v-if="isAdmin == 1"> 
                  <v-btn  color="red" class="white--text" v-if="item.banner_status == 0"  @click="changebannerstatus(item,1)"> Disabled </v-btn>
                  <v-btn  color="green" class="white--text" v-if="item.banner_status == 1"  @click="changebannerstatus(item,0)"> Enabled </v-btn>
                </template>  
                 <template v-slot:item.bannercode="{ item }">
                 <td width="10%">
                       <a href="#" @click="bannerviewmodal(item.bannerid,item.bannertitle)">
                   <v-icon  small  color="blue" class="mr-2"  >mdi-eye-check</v-icon>
                   </a>
               </td>
                </template>
                <template v-slot:item.preview="{ item }" v-if="isAdmin == 1"> 
                  <a v-if="item.websiteslug != 'droad'" target="_blank" class="btn btn-primary" :href="item.webaddress">Preview</a>
                </template>  
                <!-- Edit Delete Button-->
                <template v-slot:item.actions="{ item }"> 
                
                <!--<a v-bind:href="/adform/+item.id"><v-icon  small  class="mr-2"  >mdi-pencil</v-icon> </a>-->
                <router-link :to="'adform/'+item.id">
                    <v-icon  small  class="mr-2"  >mdi-pencil</v-icon>
                </router-link>
                
                <v-icon v-if="isAdmin == 1" small color="red" @click="deletebanner(item.bannerid)">mdi-delete</v-icon>
                </template>
            </v-data-table>
    
              <!---Dialog-->
                   <v-dialog v-model="dialog"  width="1000"   height="700">
                                    <v-card>
                                      <v-card-title class="text-h5 grey lighten-2">
                                       Preview
                                      </v-card-title>
                                      <v-card-text class="mt-5">
                                          <!---- Start Preview ---->
                                         <v-row >
                                                 <v-col cols="5" sm="5" md="5">
                                                  <v-row  justify="center">
                                                     <v-col cols="6" class="pa-2" sm="6" md="6"><h3> Banner Title : </h3></v-col>
                                                     <v-col cols="6" class="pa-2" sm="6" md="6">&nbsp;<h5> {{adtitle}}</h5></v-col>
                                                      <v-col cols="6" class="pa-2" sm="6" md="6"><h3> App. : </h3></v-col>
                                                     <v-col cols="6" class="pa-2" sm="6" md="6"> 
                                                        <div v-for="(getwebsite) in websitelist" :key="getwebsite.publisherId">
                                                            <span v-if="getwebsite.publisherId == previewwebsiteid"> <h6>{{getwebsite.publisherName}}</h6> </span>
                                                        </div>
                                                     </v-col>
                                                   <!-- 
                                                    <v-col cols="6" sm="6" class="pa-2" md="6"><h3> Zone : </h3></v-col>
                                                     <v-col cols="6" sm="6" class="pa-2" md="6"><h5>Myyyaak- Australia</h5> 
                                                     </v-col>
                                                     -->

                                                      <v-col cols="6" sm="6" class="pa-2" md="6"><h3> Placement : </h3></v-col>
                                                     <v-col cols="6" sm="6" class="pa-2" md="6">
                                                           <h5>USD {{adplacementid}}  </h5>                           
                                                        </v-col>
                                                      <v-col cols="6" sm="6" md="6" class="pa-2"><h3> Start Date : </h3></v-col>
                                                     <v-col cols="6" sm="6" md="6" class="pa-2"><h5>{{startdate}}</h5> </v-col>  

                                                     <v-col cols="6" sm="6" md="6" class="pa-2"><h3> End Date : </h3></v-col>
                                                     <v-col cols="6" sm="6" md="6" class="pa-2"><h5>{{enddate}}</h5> </v-col>
                                                     
                                                     <v-col cols="6" sm="6" md="6" class="pa-2"><h3> Ad. Type : </h3></v-col>
                                                     <v-col cols="6" sm="6" md="6" class="pa-2"><h5>{{adtype}}</h5> </v-col>
                                                     
                                                      <v-col cols="6" sm="6" md="6" class="pa-2"><h3> Destination Url : </h3></v-col>
                                                     <v-col cols="6" sm="6" md="6" class="pa-2"><h5>{{desitnationurl}}</h5> </v-col>
                                                     
                                                  </v-row>   
                                                 </v-col>  
                                              <v-col cols="7"  sm="7" md="7" justify="top">
                                                <div > 
                                                  <!--- Show Website Templates --->
                                                      <template>
                                                        <risk-template
                                                        v-if="adwebsiteslug == 'risk'"  
                                                        :bannercontent="bannercontent"
                                                       ></risk-template>
                                                     </template>
                                                     <template>
                                                        <pi3ck-template
                                                        v-if="adwebsiteslug == 'pi3ck'"  
                                                        :bannercontent="bannercontent"
                                                       ></pi3ck-template>
                                                     </template>
                                                     <template>
                                                        <quizstar-template
                                                        v-if="adwebsiteslug == 'quizstar'"  
                                                        :bannercontent="bannercontent"
                                                       ></quizstar-template>
                                                     </template>
                                                      <template>
                                                        <myvocoviewtemplate
                                                        v-if="adwebsiteslug == 'myvoco'"  
                                                        :bannercontent="bannercontent"
                                                       ></myvocoviewtemplate>
                                                     </template>
                                                       <template>
                                                        <damnntipsviewtemplate
                                                        v-if="adwebsiteslug == 'damnntips'"  
                                                        :bannercontent="bannercontent"
                                                       ></damnntipsviewtemplate>
                                                     </template>
                                                     <template>
                                                      <sportstrade-template
                                                        v-if="adwebsiteslug == 'sportrade'"  
                                                        :bannercontent="bannercontent"
                                                       ></sportstrade-template>
                                                     </template>
                                                     <template>
                                                      <myyaak-template
                                                        v-if="adwebsiteslug == 'myyaak'"  
                                                        :bannercontent="bannercontent"
                                                        :bannerposition="bannersection"
                                                       ></myyaak-template> 
                                                      <mynews-template
                                                        v-if="adwebsiteslug == 'mynews24'"  
                                                        :bannercontent="bannercontent"
                                                        :bannerposition="bannersection"
                                                       ></mynews-template>
                                                       <droad-template 
                                                        v-if="adwebsiteslug == 'droad'"  
                                                        :bannercontent="bannercontent"
                                                        :bannerposition="bannersection"
                                                       ></droad-template>
                                                     </template>
                                                  <!-----Show Website Templates ------------->   
                                                </div>      
                                              </v-col>
                                          </v-row>  
                                              <!---- End Preview ---->
                                      </v-card-text>
                                      <v-divider></v-divider>
                                     <v-card-actions class="justify-end">
                                        <v-btn
                                          color ="blue grey"
                                          @click="closebannerdialog()"
                                        >Close</v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
             <!----End Dilog----->
              <!---Dialog-->  
                   <v-dialog     v-model="bannercodedialog"  width="1050"   
                                  >
                                    <v-card>
                                      <v-card-title class="text-h5 grey lighten-2">
                                       Statistics ( {{viewbannername}} )
                                      </v-card-title>
                                      <v-card-text>
                                          <!---- Start Preview ---->
                                              <v-row>
                                             <!--   
                                              <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-text-field style="display:none;" v-model="bannerviewbyid"  class="padding-top-0 padding-bottom-0" label=""></v-text-field>
                                                    <v-select v-model="bannerviewby"  :items="bannerviewbylist" label="View By"    class="padding-top-0 padding-bottom-0" ></v-select>
                                              </v-col> -->
                                                <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                                                    <v-menu ref="from_date"  v-model="from_date"  :close-on-content-click="false"
                                                        :return-value.sync="from_date" transition="scale-transition"  offset-y  min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <v-text-field  v-model="fromdate"  label="From Date"
                                                            prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker  v-model="fromdate"  no-title  scrollable>
                                                          <v-spacer></v-spacer>
                                                          <v-btn    text  color="primary"  @click="fromdate = false">
                                                            Cancel    </v-btn>
                                                          <v-btn  text   color="primary" @click="$refs.from_date.save(from_date)" >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    </v-col>
                                                      <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                                                    <v-menu ref="to_date"  v-model="to_date"  :close-on-content-click="false"
                                                        :return-value.sync="to_date" transition="scale-transition"  offset-y  min-width="auto">
                                                        <template v-slot:activator="{ on, attrs }">
                                                          <v-text-field            v-model="todate"            label="To Date"
                                                            prepend-icon="mdi-calendar"   readonly v-bind="attrs" v-on="on"></v-text-field>
                                                        </template>
                                                        <v-date-picker  v-model="todate"  no-title  scrollable>
                                                          <v-spacer></v-spacer>
                                                          <v-btn    text  color="primary"  @click="todate = false">
                                                            Cancel    </v-btn>
                                                          <v-btn  text   color="primary" @click="$refs.to_date.save(to_date)" >OK</v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                    </v-col>
                                              <v-col cols="2" sm="2" md="2" class="padding-top-0 padding-bottom-0">
                                                    <v-btn   depressed color="primary" @click="viewbannerstats()"><v-icon left>mdi-file-search-outline
                                                      </v-icon>Search</v-btn>
                                              </v-col>
                                              <v-col cols="3" sm="3" md="3" class="padding-top-0 padding-bottom-0">
                                                    <div v-if="searchbannerdataexist">  
                                                      <template>
                                                        <div class="text-center">
                                                      <v-btn  color="success" title="Excel Download" class="mx-2"
                                                            fab  small  dark >
                                                              <export-excel 
                                                      title ="Banner Statistics"
                                                      footer="DamnN Group"
                                                      :data="getbannersbylist"
                                                      :fields="bannerstats_json_fields"
                                                      name="bannerstats.xls"
                                                      >
                                                      <v-icon>mdi-file-excel</v-icon>
                                                        </export-excel>
                                                     </v-btn>
                                                     <v-btn  @click="showgraph" color="primary"  class="mx-2"
                                                                fab  small  dark >

                                                          <v-icon v-if="showgraphsection == false" title="Stats. Chart">mdi-chart-line</v-icon>
                                                          <v-icon v-if="showgraphsection == true" title="Stats. Table">mdi-file-table-outline</v-icon> 
                                                        
                                                        </v-btn>

                                                   </div>
                                                   </template>
                                                   </div>
                                                   
                                              </v-col>
                                            </v-row> 
                                              <v-row > 
                                                 <v-col cols="12" sm="12" v-if="showtablesection"  md="12">
                                                   <!-- View By Table Data--> 
                                                          <v-data-table  :headers="bannerstatsheaders" :items="getbannersbylist" :items-per-page="5"  class="elevation-2 grey lighten-1" >
                                                                <template v-slot:itemresponce.day="{ itemresponce }">
                                                                       {{itemresponce.day}}
                                                                </template>
                                                                <template v-slot:item.hour="{ item }">
                                                                  {{ item.hour }} 
                                                                </template>
                                                                 <template v-slot:item.impressions="{ item }">
                                                                  {{ item.impressions }} 
                                                                </template>
                                                                 <template v-slot:item.clicks="{ item }">
                                                                  {{ item.clicks }} 
                                                                </template>
                                                                 <template v-slot:item.ctr="{ item }">
                                                                 {{ item.ctr }}   
                                                                </template>
                                                                <template v-slot:item.hourlydate="{ item }">
                                                                  <a href="javascript:void(0)" @click="viewhoulrybannerstats(item.hourlydate)">
                                                                      <v-icon  small  color="blue" class="mr-2"  >mdi-eye-check</v-icon>
                                                                  </a>
                                                                </template>

                                                                
                                                                 
                                                          </v-data-table>  
                                                   <!---View By Table Data-->
                                                   
                                                 </v-col>  
                                                 <v-col cols="12"  v-if="showgraphsection">
                                                   <v-card flat>
                                                   <template>
                                                  <div style="width:100%; height:300px;overflow-x:scroll;">
                                                    <bar-chart v-if="showgraphsection"
                                                    :chart-options="activityChartOptions"
                                                    :chart-data="activityChartdata"
                                                    class="walking-speed-chart-activity"
                                                    ></bar-chart>
                                                  </div>
                                                </template>
                                                    </v-card>
                                                 </v-col>  
                                              </v-row>
                                              <!---- End Preview ---->
                                          
                                      </v-card-text>
                                      <v-divider></v-divider>
                                     <v-card-actions class="justify-end">
                                        <v-btn
                                           color ="blue grey"
                                          @click="closestatsdialog"
                                        >Close</v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
             <!----End Dilog----->
             <!---Dialog-->  
                   <v-dialog v-model="bannerhourlyclosedialog"  width="500">
                      <v-card>
                        <v-card-title class="text-h5 grey lighten-2">
                          Hourly Statistics
                        </v-card-title>
                        <v-card-text>
                            <!-- View By Table Data--> 
                        <v-data-table  :headers="hourlybannerstatsheaders" :items="gethourlybannersbylist" :items-per-page="5"  class="elevation-2 grey lighten-1" >
                              <template v-slot:itemresponce.day="{ itemresponce }">
                                      {{itemresponce.day}}
                              </template>
                              <template v-slot:item.hour="{ item }">
                                {{ item.hour }} 
                              </template>
                                <template v-slot:item.impressions="{ item }">
                                {{ item.impressions }} 
                              </template>
                                <template v-slot:item.clicks="{ item }">
                                {{ item.clicks }} 
                              </template>
                                <template v-slot:item.ctr="{ item }">
                                {{ item.ctr }}   
                              </template>
                        </v-data-table>  
                      <!---View By Table Data-->
                        </v-card-text>
                        <v-divider></v-divider>
                                     <v-card-actions class="justify-end">
                                        <v-btn
                                           color ="blue grey"
                                          @click="closehourlystatsdialog"
                                        >Close</v-btn>
                                      </v-card-actions>
                      </v-card>
                    </v-dialog>
               <!----End Dilog----->     
        </v-card>
      </v-col>
    </v-row>
        
  </v-container>
</template>
<script>
//{text: 'Hourly', value: 'hourly'}
var bannerviewbyarr = [{text: 'Daily', value: 'daily'}, ] ;
var adtypearr = [{text: 'All', value: ''},{text: 'Image', value: 'web'},{text: 'Html', value: 'html'},{text: 'Video', value: 'video'}] ;

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import BarChart from '@/components/BarChart'
import RiskTemplate from '../components/Riskviewtemplate.vue'
import Pi3ckTemplate from '../components/Pi3ckviewtemplate.vue'
import QuizstarTemplate from '../components/Quizstarviewtemplate.vue'
import SportstradeTemplate from '../components/Sportstradeviewtemplate.vue'
import MyyaakTemplate from '../components/Myyaakviewtemplate.vue'
import MynewsTemplate from '../components/Mynewstemplate.vue'
import DroadTemplate from '../components/Droadtemplate.vue'
import Myvocoviewtemplate from '../components/Myvocoviewtemplate.vue';
import Damnntipsviewtemplate from '../components/Damnntipsviewtemplate.vue';

import moment from 'moment';
//import { computed } from 'vue';

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
    }
});

Vue.use(Vuex)
Vue.use(VueAxios, axios)
  export default {
    components: {
    BarChart,
    RiskTemplate,
    Pi3ckTemplate,
    QuizstarTemplate,
    SportstradeTemplate,
    MyyaakTemplate,
    MynewsTemplate,
    DroadTemplate,
    Myvocoviewtemplate,
    Damnntipsviewtemplate
  },
    data: () => ({
      
      bannerhourlydialog:false,
     bannerhourlyclosedialog:false, 
        headersection : require("@/assets/headersection.png"),
      leftsection : require("@/assets/leftsection.png"),
      middlesection:  require("@/assets/middlesection.png"),
      rightsection :  require("@/assets/rightsection.png"),
      logo: require("@/assets/logo.png"),
       adhere: require("@/assets/506.jpg"),
     // demobanner: require("@/assets/quizstar.gif"), 
      adtitle:"",
      startdate:"",
      enddate:"",
      desitnationurl:"",
      imagetooltip:"",
      dialog: false,
      bannercodedialog: false,
      dialogDelete: false,
      editid : 0,
      bannerviewby : "",
      bannerviewbylist : bannerviewbyarr,
      invocationcodetype :"",
      invocationcode:"",
      invocationzone:"",
     
      desserts: [],
      getbannerslist : [],
      bannerstatsheaders : [
        { text: 'Date', value: 'day' },
        {text: 'Views',value: 'impressions'},
        { text: 'Clicks', value: 'clicks' },
       // { text: 'Revenue', value: 'revenue' },
         { text: 'CTR', value: 'ctr' },
         { text: 'Hour Stats.', value: 'hourlydate' }, 
      ],
      hourlybannerstatsheaders : [
        { text: 'Date', value: 'day' },
        { text: 'Hour', value: 'hour' },
        {text: 'Views',value: 'impressions'},
        { text: 'Clicks', value: 'clicks' },
       // { text: 'Revenue', value: 'revenue' },
         { text: 'CTR', value: 'ctr' },
      ],
      getbannersbylist : [],
      adserverURL : process.env.VUE_APP_ADSERVER_WEB_BASEURL ,
      to_date: "",
      from_date: "",
      fromdate: "",
      todate:"",//"2022-06-30"
      searchto_date: "",
      searchfrom_date: "",
      searchfromdate: "2022-06-01",
      searchtodate: new Date().toISOString().slice(0,10),
      viewbannername:"",
      bannerviewbyid:"",
      bannerstats_json_fields: {
            'Date': 'day', 
            'Hour': 'hour',
            'Impressions': 'impressions',
            'Clicks': 'clicks',
            'CTR': 'ctr', 
            
        },
      searchbannerdataexist:false,
      websiteid:"", 
      previewwebsiteid : "",
      websitelist:[],
      websitezonelist:[],
      zoneid:"",
      adtypelist:adtypearr,
      adtype:"" ,
      chartDates: [],
      activityChartdata :"",
      activityChartOptions : "",
      showtablesection:true,
      showgraphsection:false,
      impressionsdata_arr :[],
      clicksdata_arr :[],
      advast_video_filename : "",
      advast_video_type : "",
      advast_video_duration : "",
      imgwidth :"",
      imgheight :"",
      adwebsiteslug:"",
      bannersection:"",
      gethourlybannersbylist:[],
      adplacementslist : [],
      adplacementid:"",
    }),
    created () {
     this.getBannersList();
     this.getAdserverWebsiteList();
     this.getzonelist(4);
     this.getadplacements();
     this.fromdate = this.computedFromDate;
    this.todate = this.computedToDate;
    },
    computed:{
      computedFromDate() {
      const today = new Date();
      return today.toISOString().split('T')[0]; // Today's date in 'YYYY-MM-DD'
    },
    computedToDate() {
      const oneMonthLater = new Date();
      oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
      return oneMonthLater.toISOString().split('T')[0]; // One month later in 'YYYY-MM-DD'
    },
      isAdmin(){
        if(this.$store.getters.isAdmin)
        {
          return 1;
        }
        return 0;
      },
      headers()
      {
         if(this.$store.getters.isAdmin)
         {
         return [
            { text: 'Sno.', value: 'sno', },
            { text: 'Business Name',value: 'bannertitle'},
            { text: 'Website',value: 'website'},
            { text: 'Start Date', value: 'startdate' },
            { text: 'Expire Date', value: 'enddate' },
            { text: 'Amount', value: 'adplacementid' },
            { text: 'Remaining Amount', value: 'remaining_amount' },
            /*{ text: 'Banner Type (Image/ Html)', value: 'adtype' },*/
            { text: 'Preview', value: 'preview' },
            { text: 'Stats. Report', value: 'bannercode' },
            { text: 'Status', value: 'status', sortable: false },
            { text: 'Actions', value: 'actions', sortable: false },
           ];
         }  
         else{
          return [
            { text: 'Sno.', value: 'sno', },
                    { text: 'Business Name',value: 'bannertitle'},
            { text: 'Website',value: 'website'},
            { text: 'Start Date', value: 'startdate' },
            { text: 'Expire Date', value: 'enddate' },
            { text: 'Amount', value: 'adplacementid' },
           /* { text: 'Banner Type (Image/ Html)', value: 'adtype' },*/
            { text: 'Stats. Report', value: 'bannercode' },
            { text: 'Actions', value: 'actions', sortable: false },
           ];
         }
      } 
    },
    methods: {
       changebannerstatus(item,status){
         item.banner_status = status;
         this.$store.dispatch("bannerstatus",{bannerid:item.id,bannerstatus:status}).then(() => {

         });
       },
       getadplacements(){
             this.$store.dispatch("quizstaradplacements",{
              })
              .then(response => {
                this.adplacementslist = response.data;
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Website Ad Placements error");
                console.log(error);
              });
      } ,
     currentDate() {
      const current = new Date();
      const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
      console.log('Current Date ' +date);
      return date;
    },
      closebannerdialog(){
       this.dialog = false    
      },
      getFormattedDate(date) {
            return moment(date).format("YYYY/MM/DD")
        },
      showgraph()
      { 
       

        this.activityChartdata = {
        labels: [],
        datasets: [
           {
            label: "Impressions",
            backgroundColor: "lightblue",
            borderColor: "blue",
            borderWidth: 1,
            data: []
        },
        {
            label: "Clicks",
            backgroundColor: "lightgreen",
            borderColor: "green",
            borderWidth: 1,
            data: []
        }
          ]
      };

       this.activityChartOptions = {
          responsive: false,
          maintainAspectRatio: false,
          tooltips: {
            displayColors: false,
          },
          aspectRatio:4 ,//(width/height),
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                    beginAtZero:true,
               //   stepSize: 10,
                  min: 0,
                  max: 100
                },
              },
            ],
         
          },
        };




        this.chartDates = [];
        this.impressionsdata_arr = [];
         this.clicksdata_arr = [];
        // Here Fetch Data For Chart   
         for (var i = 0; i < this.getbannersbylist.length; i++) 
               {
                 this.chartDates.push(this.getbannersbylist[i].day);
                 this.impressionsdata_arr.push(this.getbannersbylist[i].impressions);
                 this.clicksdata_arr.push(this.getbannersbylist[i].clicks);
               }    
               this.activityChartdata.datasets[0].data = this.impressionsdata_arr;     
               this.activityChartdata.datasets[1].data = this.clicksdata_arr;
               this.activityChartdata.labels = this.chartDates;
        // End
         console.log(this.impressionsdata_arr);

        if(this.showgraphsection == true)
        {
          this.showgraphsection = false;
          this.showtablesection = true;
        }else
        {

          this.showgraphsection = true;
          this.showtablesection = false;
        }
      },
      getexcelfilename(){
        return "bannerstats-"+this.viewbannername+"-"+this.bannerviewby+".xls";
      },
    getAdserverWebsiteList() {
      this.$store.dispatch("retrieveAdserverWebsitesList", {
        })
        .then(response => {
          this.websitelist = response;
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Website List error");
          console.log(error);
        });
    },
      getzonelist(getwebsiteid)
          {
              this.$store.dispatch("retrieveWebsiteZoneList",{websiteid : getwebsiteid}, {
              })
              .then(response => {
                console.log(response.data);
                this.websitezonelist = response.data;
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Website Zone List error");
                console.log(error);
              });
          },
      viewhoulrybannerstats(getfromdate){
        // alert(this.bannerviewby+"<>"+this.fromdate+"<>"+this.todate+"<>"+this.bannerviewbyid);
             var bannerviewby  = "hourly";
             var fromdate  = getfromdate;
             var todate  = getfromdate;
             var bannerid = this.bannerviewbyid;
            
            this.bannerhourlydialog = true;
            this.bannerhourlyclosedialog = true;
              this.$store.dispatch("adserverbannerstats",{bannerviewby:bannerviewby
              ,fromdate:fromdate
              ,todate:todate
              ,bannerid:bannerid
              }, {
              })
              .then(response => {
                for (var i = 0; i < response.data.length; i++) {
                     
                  //if(this.bannerviewby == "hourly")
                 //{    
                  var getdate =  response.data[i].day+" "+response.data[i].hour+":00:00"; 
                 
                // }
                  response.data[i].day  =  require("moment")(
                              response.data[i].day
                              ).format("D/MM/YYYY");
                 //if(this.bannerviewby == "hourly")
                 //{ 
                  response.data[i].hour  =  require("moment")(
                             // response.data[i].hour
                             getdate
                              ).format("HA");            
                      //console.log(datett); 
                 //}     
                  var getctr = ""
                    if(response.data[i].impressions > 0 && response.data[i].clicks >0)
                    {
                      getctr =  (response.data[i].clicks / response.data[i].impressions * 100).toFixed(2);
                       getctr =  getctr+"%";
                    }                       
                    response.data[i].ctr =  getctr;


                }
               this.gethourlybannersbylist = response.data;
               console.log("Hourly Stats.");
               console.log(this.gethourlybannersbylist);
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Banner Stats List error");
                console.log(error);
              });
      },    
      viewbannerstats(){
        // alert(this.bannerviewby+"<>"+this.fromdate+"<>"+this.todate+"<>"+this.bannerviewbyid);
             var bannerviewby  = "daily";// this.bannerviewby;
             var fromdate  = this.fromdate;
             var todate  = this.todate;
             var bannerid = this.bannerviewbyid;
            //  this.chartDates = [];
            //  this.impressionsdata_arr = [];
            //  this.clicksdata_arr = [];
              this.showgraphsection = false;
              this.showtablesection = true;
              this.getbannersbylist = [];
                 

             if(bannerviewby =="")
             { 
              this.$alert("Please select view by.","View By","fail");
               return false;
             }
             
              this.$store.dispatch("adserverbannerstats",{bannerviewby:bannerviewby
              ,fromdate:fromdate
              ,todate:todate
              ,bannerid:bannerid
              }, {
              })
              .then(response => {

             
                for (var i = 0; i < response.data.length; i++) {
                     
                  if(this.bannerviewby == "hourly")
                 {    
                  var getdate =  response.data[i].day+" "+response.data[i].hour+":00:00"; 
                 
                 }

                 response.data[i].hourlydate = response.data[i].day;
                  response.data[i].day  =  require("moment")(
                              response.data[i].day
                              ).format("D/MM/YYYY");
                 if(this.bannerviewby == "hourly")
                 { 
                  response.data[i].hour  =  require("moment")(
                             // response.data[i].hour
                             getdate
                              ).format("HA");            
                      //console.log(datett); 
                 }     

                 if(this.bannerviewby == "hourly")
                 {    
                 // response.data[i].datehours[get_date] = response.data[i].hour;

                 }

                     var getctr = ""
                    if(response.data[i].impressions > 0 && response.data[i].clicks >0)
                    {
                      getctr =  (response.data[i].clicks / response.data[i].impressions * 100).toFixed(2);
                       getctr =  getctr+"%";
                    }                       
                    response.data[i].ctr =  getctr;


                }
                 this.getbannersbylist = response.data;
                

              if(this.getbannersbylist !="")
              {
                this.searchbannerdataexist = true;
              }
              // console.log("Testing");
               console.log(this.getbannersbylist);
            })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Banner Stats List error");
                console.log(error);
              });
      },
       getbanner(bannerid){
      //  this.selectWeb(1);
      var banner_id = bannerid;

       this.$store
        .dispatch("quizstarbannerdetails", {bannerid : banner_id})
        .then(response => {
         
          this.adwebsiteslug = response.data.websiteslug;
          this.previewwebsiteid = response.data.websiteid;
          this.adtitle = response.data.bannertitle;

          this.adplacementid = response.data.price;
          
          var getstartdate = new Date(response.data.startdate);
          this.startdate = getstartdate.getDate()+"/"+(getstartdate.getMonth()+1)+"/"+getstartdate.getFullYear();
          
          var getenddate = new Date(response.data.enddate);
          this.enddate = getenddate.getDate()+"/"+(getenddate.getMonth()+1)+"/"+getenddate.getFullYear();
        
          this.adtype = response.data.adtype;
          this.desitnationurl = response.data.desitnationurl;
          this.imagetooltip = response.data.imagetooltip;
          this.demobanner = this.adserverURL+"/images/"+response.data.bannerimage; 
         
          this.htmltemplate = response.data.htmltemplate;
       
          this.advast_video_filename = response.data.videourl;
          this.advast_video_type = response.data.videotype;
          this.advast_video_duration = response.data.videoduration;

          this.imgwidth = response.data.bannerwidth;
          this.imgheight = response.data.bannerheight;

          this.bannersection = response.data.bannersection;



           if(this.adtype =="html")
            {
            this.bannercontent = this.htmltemplate;
            }

            if(this.adtype =="web")
            {
               this.bannercontent='<img class="list-item" width = "100%" height = "100%" alt="Avatar" src="'+this.demobanner+'" >'
            }

              if(this.adtype =="video")
            {
              this.demobanner = "";
              var videohtml = ""
              if(response.data.websiteslug == "myyaak")
                videohtml = '<video  width = "360px" height = "200px" class="myvideo" controls ><source src="'+this.advast_video_filename+'" type ="video/mp4"></video>';
              else
                videohtml = '<video width = "150px" height = "150px" controls ><source src="'+this.advast_video_filename+'" type ="video/mp4"></video>';

              this.bannercontent = videohtml;
            }
          
              })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Quizstar Banner details error");
          console.log(error);
        });
        
     },
      showdetails (getbannerid){
      this.getbanner(getbannerid);
         this.dialog = true
      },
      closestatsdialog()
      {
         this.bannercodedialog = false;  
      },
      closehourlystatsdialog()
      {
         this.bannerhourlyclosedialog = false;  
      },
      bannerviewmodal(getbannerid,getbannertitle){
        this.bannerviewby = "";
        this.showgraphsection = false;
        this.showtablesection = true;
        this.getbannersbylist = [];
           
         this.bannerviewbyid = getbannerid;
         this.viewbannername = getbannertitle;
         this.searchbannerdataexist = false;
        this.bannercodedialog = true
      },
      getbannercode(getcodetype){
       var getzoneid = this.invocationzone;
       var getbannercodetype = getcodetype;
       this.$store.dispatch("adserverbannercode",{zoneid:getzoneid
        ,bannercodetype:getbannercodetype
        }, {
        })
        .then(response => {
         this.invocationcode = response.invocation_code;
         // console.log(response);
      })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("Website List error");
          console.log(error);
        });

      },
    deleteadserverbanner(getbannerid){
        let formData = new FormData();
         formData.append('bnn', "banner");
         formData.append('bannerid', getbannerid);
         this.$store.dispatch("adserverdeletebanner",formData)
              .then(response => {
                   console.log(response);
                    this.$alert("Banner has been deleted successfully.","Banner","success").then(() => { 
                      this.$router.go();
                      });
                    })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Delete Banner error");
                console.log(error);
              });  
     },
     deletebanner(getbannerid){
        this.$confirm("Are you sure?").then(() => {
             this.$store
              .dispatch("quizstardeletebanner",{bannerid :getbannerid })
              .then(response => {
                console.log(response);
                    this.deleteadserverbanner(getbannerid);
                // this.$alert("Banner has been deleted successfully.","Banner","success");
                    //this.$router.push({ name: "adlist" });
                      
                    })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Delete Banner error");
                console.log(error);
              }); 
              
          });  
            
     },
     deletebannerquizstar(bannerid)
     {
     
          this.$store
              .dispatch("quizstardeletebanner",{bannerid :bannerid })
              .then(response => {
                console.log(response);
                 
                // this.$alert("Banner has been deleted successfully.","Banner","success");
                    //this.$router.push({ name: "adlist" });
                      this.$router.go();
                    })
              .catch(error => {
                // TODO: handle incorrect login
                console.log("Delete Banner error");
                console.log(error);
              });  
     },
      editItem (item) {
        this.editedIndex = this.getquestionlist.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.editid = item.id;
        console.log(this.editid);
      },

      deleteItem (item) {
        this.editedIndex = this.getquestionlist.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.getquestionlist.splice(this.editedIndex, 1)
        this.closeDelete()
      },
     getBannersList() { 
      this.$store.dispatch("quizstarbannerlist",
       {
           websiteid : this.websiteid,
           adtype : this.adtype,
           fromdate : this.searchfromdate,
           todate : this.searchtodate 
        }
      ).then(response => {  
       
            for (var i = 0; i < response.data.length; i++) {
                 
                 // var startdate = response.data[i].startdate;
               //   var enddate = response.data[i].enddate;

                  response.data[i].startdate  =  require("moment")(
                              response.data[i].startdate
                              ).format("D/MM/YYYY");
                  
                  response.data[i].enddate  =  require("moment")(
                             response.data[i].enddate
                              ).format("D/MM/YYYY"); 

                  
                }
        //this.getbannerslist = this.$store.state.quizstarbannerlist;
        this.getbannerslist = response.data;
        if(this.getbannerslist.length ==0)
        {
          this.$router.push({ name: "adform" });
        }
         ///console.log(this.$store.getters.quizstarbannerlist);
      });
    },
      bannerRefund(bannerid,amount) {
        this.$store.dispatch("bannerRefund",{
            amount:amount,
            bannerid:bannerid,
            app_type:'adserver'
          }).then(() => {
            //this.showinbankbalance = this.$store.getters.showamount;
            //this.showkelamount = this.$store.getters.showkelamount;
           // this.getBalance();
         });
     },
     getBalance() {
      //this.$store.dispatch("retrieveBalance").then(() => {
       // this.balance = this.$store.getters.balance;
      //});

      this.$store.dispatch("retrieveInbankKelBalance").then(() => {
            this.balance = this.$store.getters.showamount;
           });

    },
    },
  }
</script>
<style>
#bar-chart1{width:100% !important;height: 300px !important; position: relative !important;}
#line-chart{width:100% !important;height: 100% !important; position: relative !important;}
.walking-speed-chart-activity {
  height: 250px;
  width: 100%;/*1000px;*/
}
</style>
<style scoped>
.stripe-card {
  /* width: 300px; */
  border-bottom: 1px solid grey;
}

.InputElement.Input {
  color: white !important;
}
.draggablecontent{background-size: 100% 100%;height: 120px;}
.bannerimg{width: 100%;height: 100%;}
.graphsection{height: 250px !important;}
</style>